import { getNotificationsCount } from '@api/notifications';
import { useQuery } from '@tanstack/react-query';

export const useNotificationsCount = () => {
  const { data } = useQuery({
    queryKey: ['notifications-count'],
    queryFn: () => getNotificationsCount(),
  });

  return data?.unreadCount;
};
